import axios from 'axios';
import { setHeaders } from './headers.mjs';
import { API_BASE_URLS } from './config.mjs'; // Ensure correct import
import { store } from '../store/store.js';
import { authenticateActions } from "../store/store.js";
import { adminServiceAPI as clientServiceAPI } from '../api/axiosInstance.js'

// clientServiceAPI.interceptors.response.use(
//   (response) => response, // If success, just return the response
//   (error) => {
//     if (

//       (error?.response?.data?.message === "Invalid or expired access token" || error?.response?.data?.message ==="Invalid or Missing AccessToken")
//     ) {

//      store.dispatch(authenticateActions.logout());
//           localStorage.removeItem("refreshToken");
//           window.location.href = "/login";


//         }
//       return
//   }
// );
clientServiceAPI.interceptors.response.use(
  (response) => response, // If success, just return the response
  (error) => {
    const message = error?.response?.data?.message;

    if (
      message === "Invalid or expired access token" ||
      message === "Invalid or Missing AccessToken"
    ) {
      store.dispatch(authenticateActions.logout());
      localStorage.removeItem("refreshToken");
      window.location.href = "/login";
    }

    // Always return or reject the error to keep the chain working
    return Promise.reject(error);
  }
);


const proxyRequest = async (service, endpoint, method, body = null, userId = null, token = null, tenantId, useStaticTenant = false) => {
  try {
    if (!endpoint) {
      console.error('🚨 ERROR: `endpoint` is undefined in `proxyRequest`');
      throw new Error('Invalid API call: `endpoint` is missing');
    }

    console.log('tenantId in proxyRequest:', tenantId);
    const targetURL = `${API_BASE_URLS[service]}${endpoint}`;
    const headers = setHeaders(true, useStaticTenant ? "napid_auth" : tenantId);
    const requestData = method === 'GET' ? {} : { endpoint, ...body }; // For GET, leave body empty
    // Make the request via the proxy server
    const response = await clientServiceAPI({
      method: method,
      url: '/client',
      params: method === 'GET' ? { endpoint } : {},  // Pass `endpoint` as query param for GET
      data: method !== 'GET' ? requestData : undefined, // Send data only for non-GET requests
      headers: headers,
    });
    return response.data;

  } catch (error) {
    if (
      error.response.data.statusCode === "FAILED" &&
      error.response.data.message === "Invalid or expired access token"
    ) {
      window.location.href = "/login";
    }

    return error.response.data;
  }
};



export const ClientAPI = {
  loginUser: async (userId) => {
    const endpoint = '/client/v1/transaction/napidauth/logincheck';
    return proxyRequest('CLIENT_SERVICE', endpoint, 'POST', { userId, "apiSecret": "11f0fa8e-8bf9-4201-bbe1-9200070b5a0f" }); // Send userId for login (no token)
  },

  createSubscription: async (subscriptionData) => {
    const endpoint = '/client/v1/subscription';
    return proxyRequest('CLIENT_SERVICE', endpoint, 'POST', { ...subscriptionData }); // Send token for subscription
  },

  addApplication: async (newApplicationData, tenantId) => {
    console.log("tenantID:", tenantId)
    const endpoint = '/client/v1/application';
    return proxyRequest('CLIENT_SERVICE', endpoint, 'POST', { ...newApplicationData }, null, null, tenantId, false);
    // Send token for subscription
  },
  addRegistrationTime: async (token, timeData) => {
    const endpoint = '/client/v1/user/timeconfiguration';
    return proxyRequest('CLIENT_SERVICE', endpoint, 'POST', { ...timeData }); // Send token for subscription
  },
  createAdmin: async (adminData) => {
    console.log(adminData)
    const endpoint = '/client/v1/user';
    return proxyRequest('CLIENT_SERVICE', endpoint, 'POST', { ...adminData }, null, null, null, 'napid_auth'); // Send token for subscription
  },
  uploadCardImage: async (base64Image) => {
    const endpoint = '/client/v1/user/uploadimage';

    // Create FormData
    const formData = new FormData();
    formData.append('base64Image', base64Image); // Ensure this is base64 or a file object
    formData.append('type', 'cardimage'); // Add image type

    return proxyRequest('CLIENT_SERVICE', endpoint, 'POST', formData, 'napid_auth');
  },

  uploadJSLogo: async (token, base64Image, applicationId, jsLogoIsEnabled, tenantId) => {
    const endpoint = '/client/v1/user/uploadimage';
    const formData = new FormData();
    formData.append('base64Image', base64Image);
    formData.append('applicationId', applicationId);
    formData.append('jsLogoIsEnabled', jsLogoIsEnabled ? 'true' : 'false');
    return proxyRequest('CLIENT_SERVICE', endpoint, 'POST', formData, tenantId); // Send token for subscription
  },
  addSmsNumber: async (smsData) => {
    const endpoint = '/client/v1/sms/sendernumber';
    return proxyRequest('CLIENT_SERVICE', endpoint, 'POST', { ...smsData }); // Send token for subscription
  },
  addBlacklistIp: async (ipData) => {
    const endpoint = '/client/v1/user/blacklist-ip';
    return proxyRequest('CLIENT_SERVICE', endpoint, 'POST', { ...ipData }); // Send token for subscription
  },
  addWhitelistIp: async (ipData) => {
    const endpoint = '/client/v1/user/whitelist-ip';
    return proxyRequest('CLIENT_SERVICE', endpoint, 'POST', { ...ipData }); // Send token for subscription
  },
  addCountry: async (timeData) => {
    const endpoint = '/client/v1/user/countryinfodetails';
    return proxyRequest('CLIENT_SERVICE', endpoint, 'POST', { ...timeData }); // Send token for subscription
  },
  extension: async (subscriptionId, newExpiryDate) => {
    const endpoint = `/client/v1/subscription/extension/${subscriptionId}/${newExpiryDate}`;
    return proxyRequest('CLIENT_SERVICE', endpoint, 'POST', {}, null); // Send token for subscription
  },
  renewSubscription: async (subscriptionId) => {
    const endpoint = `/client/v1/subscription/renew/${subscriptionId}`;
    return proxyRequest('CLIENT_SERVICE', endpoint, 'POST', {}, null); // Send token for subscription
  },
  goLive: async (subscriptionId) => {
    const endpoint = `/client/v1/subscription/golive/${subscriptionId}`;
    return proxyRequest('CLIENT_SERVICE', endpoint, 'POST', {}, null); // Send token for subscription
  },
  uploadNapidLogo: async (token, base64Image, napidLogo) => {
    const endpoint = '/client/v1/user/uploadjslogo';
    const formData = new FormData();
    formData.append('base64Image', base64Image); // Ensure this is the file object to upload
    formData.append('type', "napidLogo"); // Ensure this is the file object to upload
    return proxyRequest('CLIENT_SERVICE', endpoint, 'POST', {}, null, formData, "napid_auth"); // Send token for subscription
  },

  getAllSubscriptions: async () => {
    const endpoint = '/client/v1/subscription';
    return proxyRequest('CLIENT_SERVICE', endpoint, 'GET', {}, "napid_auth"); // Send token for subscription
  },
  fetchRegistrationData: async () => {
    const endpoint = '/client/v1/user/timeconfiguration';
    return proxyRequest('CLIENT_SERVICE', endpoint, 'GET', {}, "napid_auth"); // Send token for subscription
  },
  fetchTenants: async () => {
    const endpoint = '/client/v1/getalltenantid';
    return proxyRequest('CLIENT_SERVICE', endpoint, 'GET', {}, "napid_auth"); // Send token for subscription
  },
  getAllApps: async () => {
    const endpoint = '/client/v1/user/allapplicationname';
    return proxyRequest('CLIENT_SERVICE', endpoint, 'GET', {}, null); // Send token for subscription
  },
  getAdmins: async () => {
    const endpoint = '/client/v1/user/all';
    return proxyRequest('CLIENT_SERVICE', endpoint, 'GET', null, null, null, 'napid_auth');
  },

  getAllRoles: async () => {
    const endpoint = '/client/v1/user/role/all';
    return proxyRequest('CLIENT_SERVICE', endpoint, 'GET', null, null, null, 'napid_auth'); // Send token for subscription
  },
  getDefaultCardImage: async () => {
    const endpoint = '/client/v1/user/logo/cardimage';
    return proxyRequest('CLIENT_SERVICE', endpoint, 'GET', null, null, null, 'napid_auth'); // Send token for subscription
  },
  getClientLogo: async () => {
    const endpoint = '/client/v1/user/logo/clientlogo';
    return proxyRequest('CLIENT_SERVICE', endpoint, 'GET', null, null, null, 'napid_auth'); // Send token for subscription
  },
  getSmsNumber: async (selectedType) => {
    const endpoint = `/client/v1/sms/sendernumber/apptype/${selectedType}`;
    return proxyRequest('CLIENT_SERVICE', endpoint, 'GET', null); // Send token for subscription
  },
  getCountry: async () => {
    const endpoint = '/client/v1/user/countryinfodetails';
    return proxyRequest('CLIENT_SERVICE', endpoint, 'GET', null); // Send token for subscription
  },
  getWhitelistIps: async () => {
    const endpoint = '/client/v1/user/whitelist-ips';
    return proxyRequest('CLIENT_SERVICE', endpoint, 'GET', null); // Send token for subscription
  },
  getBlacklistIps: async () => {
    const endpoint = '/client/v1/user/blacklist-ips';
    return proxyRequest('CLIENT_SERVICE', endpoint, 'GET', null); // Send token for subscription
  },
  getHistorySubscription: async () => {
    const endpoint = '/client/v1/subscription/history';
    return proxyRequest('CLIENT_SERVICE', endpoint, 'GET', {}, null); // Send token for subscription
  },
  getNapidLogo: async () => {
    const endpoint = '/client/v1/user/logo/napidLogo';
    return proxyRequest('CLIENT_SERVICE', endpoint, 'GET', null, null, null, 'napid_auth'); // Send token for subscription
  },
  updateApplication: async (applicationUpdateData, tenantId) => {
    const endpoint = '/client/v1/application';
    return proxyRequest('CLIENT_SERVICE', endpoint, 'PUT', { ...applicationUpdateData }, null, null, tenantId, false); // Send token for subscription
  },
  editApplicationMessage: async (applicationId,
    messageCode,
    message,
    tenantId,
    lightTextColor,
    darkTextColor) => {
    const editMessages = {
      applicationId,
      messageCode,
      message,

      lightTextColor,
      darkTextColor

    }
    const endpoint = '/client/v1/jstext/message';
    return proxyRequest('CLIENT_SERVICE', endpoint, 'PUT', { ...editMessages }, null, null, tenantId, false); // Send token for subscription
  },
  updateRegistrationTime: async (id, registerTime, appType) => {
    const endpoint = `/client/v1/user/timeconfiguration/id/${id}/apptype/${appType}/registrationtime/${registerTime}`;
    return proxyRequest('CLIENT_SERVICE', endpoint, 'PUT', {}, null); // Send token for subscription
  },
  updateApplicationTimes: async (applicationId,
    awakeTime,
    napidCheckTime,
    tenantId) => {
    console.log(tenantId)
    const endpoint = `/client/v1/application/applicationid/${applicationId}/awaketime/${awakeTime}/napidchecktime/${napidCheckTime}`;
    return proxyRequest('CLIENT_SERVICE', endpoint, 'PUT', {}, null, null, tenantId, false); // Send token for subscription
  },
  editAdmin: async (updatedAdminData) => {
    const endpoint = '/client/v1/user';
    return proxyRequest('CLIENT_SERVICE', endpoint, 'PUT', { ...updatedAdminData }, null, null, null, 'napid_auth'); // Send token for subscription
  },
  activateOrDeactivateUser: async (customerId, isActive) => {
    const endpoint = `/client/v1/user/activeorinactive/customerId/${customerId}/status/${isActive ? 1 : 0
      }`;
    return proxyRequest('CLIENT_SERVICE', endpoint, 'PUT', {}, null, customerId, isActive, { "X-TenantID": "napid_auth" }); // Send token for subscription
  },
  updateSubscriptionUserCount: async (userCountData) => {
    const endpoint = '/client/v1/subscription/user';
    return proxyRequest('CLIENT_SERVICE', endpoint, 'PUT', { ...userCountData }); // Send token for subscription
  },
  updateSubscriptionApplicationCount: async (applicationData) => {
    const endpoint = '/client/v1/subscription/application';
    return proxyRequest('CLIENT_SERVICE', endpoint, 'PUT', { ...applicationData }); // Send token for subscription
  },
  updateSmsNumber: async (updatedSmsData) => {
    const endpoint = '/client/v1/sms/sendernumber';
    return proxyRequest('CLIENT_SERVICE', endpoint, 'PUT', { ...updatedSmsData }); // Send token for subscription
  },
  updateRegistrationTimes: async (id, registerTime, appType) => {
    const endpoint = `/client/v1/user/timeconfiguration/id/${id}/apptype/${appType}/deletedrecordsvalidity/${registerTime}`;
    return proxyRequest('CLIENT_SERVICE', endpoint, 'PUT', {}, null); // Send token for subscription
  },
  updateCountry: async (timeData) => {
    const endpoint = '/client/v1/user/countryinfodetails';
    return proxyRequest('CLIENT_SERVICE', endpoint, 'PUT', { ...timeData }); // Send token for subscription
  },
  updateWhitelistIP: async (ipData) => {
    const endpoint = '/client/v1/user/whitelist-ips';
    return proxyRequest('CLIENT_SERVICE', endpoint, 'PUT', { ...ipData }); // Send token for subscription
  },
  updateBlacklistIP: async (blacklistData) => {
    const endpoint = '/client/v1/user/blacklist-ips';
    return proxyRequest('CLIENT_SERVICE', endpoint, 'PUT', { ...blacklistData }); // Send token for subscription
  },
  deleteApplication: async (applicationId, tenantID) => {
    const endpoint = `/client/v1/application/${applicationId}`;
    return proxyRequest('CLIENT_SERVICE', endpoint, 'DELETE', {}, null, { applicationId }, tenantID); // Send token for subscription
  },
  deleteAdmin: async (adminId) => {
    const endpoint = `/client/v1/user/${adminId}`;
    return proxyRequest('CLIENT_SERVICE', endpoint, 'DELETE', {}, null, null, null, 'napid_auth'); // Send token for subscription
  },
  deleteSmsNumber: async (adminId) => {
    const endpoint = `/client/v1/sms/sendernumber/id/${adminId}`;
    return proxyRequest('CLIENT_SERVICE', endpoint, 'DELETE', {}, null, { adminId }, { "X-TenantID": "napid_auth" }); // Send token for subscription
  },
  deleteWhiteListIp: async (adminId) => {
    const endpoint = `/client/v1/user/whitelist-ip/${adminId}`;
    return proxyRequest('CLIENT_SERVICE', endpoint, 'DELETE', {}, null, { adminId }); // Send token for subscription
  },
  deleteBlackListIp: async (adminId) => {
    const endpoint = `/client/v1/user/blacklistip/${adminId}`;
    return proxyRequest('CLIENT_SERVICE', endpoint, 'DELETE', {}, null, { adminId }); // Send token for subscription
  },
  fetchTotalUserCountData: async () => {
    const endpoint = '/client/v1/subscription/totalcustomers/count';
    return proxyRequest('CLIENT_SERVICE', endpoint, 'GET', null);
  },
  fetchUsedUserCountData: async () => {
    const endpoint = '/client/v1/subscription/addedcustomer/count';
    return proxyRequest('CLIENT_SERVICE', endpoint, 'GET', null);
  },
  fetchTotalApplicationCountData: async () => {
    const endpoint = '/client/v1/subscription/totalapplication/count';
    return proxyRequest('CLIENT_SERVICE', endpoint, 'GET', null);
  },
  fetchUsedApplicationCountData: async () => {
    const endpoint = '/client/v1/application/totaladdedcount';
    return proxyRequest('CLIENT_SERVICE', endpoint, 'GET', null);
  },
  fetchAdminApplication: async () => {
    const endpoint = '/client/v1/report/adminauth/application';
    return proxyRequest('CLIENT_SERVICE', endpoint, 'GET', null);
  },
  getAdminApplication: async () => {
    const endpoint = `/client/v1/report/adminauth/application`;
    return proxyRequest('CLIENT_SERVICE', endpoint, 'GET', null, null, null);
  },
  getAdminsMobileNumber: async (id) => {
    const endpoint = `/client/v1/user/${id}`;
    return proxyRequest('CLIENT_SERVICE', endpoint, 'GET', null, null, null, 'napid_auth');
  },
  getrenewalApplication: async () => {
    const endpoint = `/client/v1/application/all/customerapp/tenant`;
    return proxyRequest('CLIENT_SERVICE', endpoint, 'GET', null, null, null);
  },
  getApiSecretByAppId: async (appId) => {
    const endpoint = `/client/v1/apisecret/${appId}`;
    return proxyRequest('CLIENT_SERVICE', endpoint, 'GET', null, null, null);
  },
  createNewApiSecret: async (payload) => {
    const endpoint = '/client/v1/apisecret/generate';
    // return proxyRequest('CLIENT_SERVICE', endpoint, 'POST', null, null, null);
    return proxyRequest('CLIENT_SERVICE', endpoint, 'POST', { ...payload });
  },
  deleteApiSecretKey: async (apiSecretKey) => {
    const endpoint = `/client/v1/apisecret/${apiSecretKey}`;
    return proxyRequest('CLIENT_SERVICE', endpoint, 'DELETE', {}, null); // 
  },
  activeInactiveApiSecretKey: async (payload) => {
    const endpoint = '/client/v1/apisecret/activeorinactive';
    return proxyRequest('CLIENT_SERVICE', endpoint, 'PUT', { ...payload });
  },
  searchForensicReportByUTR: async (payload) => {
    const endpoint = '/client/v1/report/token';
    return proxyRequest('CLIENT_SERVICE', endpoint, 'POST', { ...payload });
  },
  addIssuerKey: async (payload) => {
    const endpoint = '/client/v1/issuer/key';
    return proxyRequest('CLIENT_SERVICE', endpoint, 'POST', { ...payload });
  },
  getIssuerDetails: async () => {
    const endpoint = '/client/v1/issuer/key'
    return proxyRequest('CLIENT_SERVICE', endpoint, 'GET', null, null, null);
  },
  deactivateIssuerKey: async (payload) => {
    const endpoint = '/client/v1/issuer/key/deactivate'
    return proxyRequest('CLIENT_SERVICE', endpoint, 'PUT', { ...payload });
  },
  get2FaPagesConfig: async () => {
    const endpoint = '/client/v1/2fa/page/details';
    return proxyRequest('CLIENT_SERVICE', endpoint, 'GET', null, null, null);
  },
  get2FaPageConfigByApiSecret: async (apiSecretKey) => {
    const endpoint = `/client/v1/2fa/page/details/${apiSecretKey}`;
    return proxyRequest('CLIENT_SERVICE', endpoint, 'GET', null, null, null);
  },
  update2FaPageConfig: async (payload) => {
    const endpoint = `/client/v1/2fa/page/details`;
    return proxyRequest('CLIENT_SERVICE', endpoint, 'PUT', { ...payload });
  },
};

export default ClientAPI;